import UAParser from 'ua-parser-js';
const uaparser = new UAParser();
import forEach from 'async/forEach.js';
import * as PIXI from 'pixi.js-legacy';
import { toPairs, isString, values, uniq } from 'lodash';
import * as pixiPackerParser from '@/play/components/pixiPackerLoader.js';
import VideoAssets from './videoassets';
//const pixiPackerParser = require("./pixiPackerLoader.js")

const VIDEO_ASSETS = new VideoAssets();

function Assets(api, loader, vue, packerData, gameId) {
  this.gameId = gameId;
  this.api = api
  this.loader = loader;
  this.assetsAlreadyLoaded = {};
  this.vue = vue;
  this.firstLoad = true;
  this.packerData = packerData;
  //this.hasPacker = !!this.packerData
  this.hasPacker = !!this.packerData

  this.videoPromises = [];


  if (this.hasPacker) {
    let packerManifest = this.packerData['game_EN_web_0.5'];
    if ((window.devicePixelRatio && window.devicePixelRatio >= 2) || window.innerWidth > 800) {
      packerManifest = this.packerData['game_EN_web_1.0'];
    }
    if (!packerManifest.spritesheets.length) {
      this.hasPacker = false;
    } else {
      this.adjustPackerDataForDevice(this.packerData);

      function base64(str) {
        return 'data:application/json;base64,' + btoa(str);
      };

      this.loader.use(pixiPackerParser(PIXI))

      this.loader.add("game_EN_web", base64(JSON.stringify(packerManifest)), {
        metadata:{
          baseUrl:this.api.makePackerUrl(this.gameId)
        },
        crossOrigin:true
      });
    }

  }
}
Assets.prototype.adjustPackerDataForDevice = function (packerData) {
  const isSafari = uaparser.getBrowser().name.toLowerCase().includes('safari');
  if (isSafari) {
    return;
  }

  Object.values(packerData).forEach( (group) => {
    group.spritesheets.forEach( (spritesheet) => {
      spritesheet.image = spritesheet.image.replace('.png', '.webp');
    });
  });
}

Assets.prototype.load = async function (allComponents, allLinks) {
  this.allComponents = allComponents;
  this.allLinks = allLinks;

  const assets = this.buildAssets();

  this.mipmappedTextures = {};
  const {mipmappedTextures, resources} = await this.loadAssets(assets);
  return {
    mipmappedTextures,
    resources,
    assets
  }

}
Assets.prototype.buildAssets = function () {
  const assets = {
    sounds:[],
    sprites:[],
    atlases:[],
    spines:[],
    videos:[],
    tilesets:[]
  }
  const self = this;
  function getAssetsFromComponent(c) {
    if (c.type === "sprite") {
      if (c.b64) {
        !self.assetAlreadyLoaded('sprite', c.id) && assets.sprites.push({
          b64:c.b64,
          name:c.id
        })
      } else {
        if (!c.anims) {
          if (self.hasPacker) {
            return;
          }
          if (c.atlas) {
            !self.assetAlreadyLoaded('sprite', c.atlas) && assets.atlases.push(c.atlas);
          } else {
            !self.assetAlreadyLoaded('sprite', c.sprite) && assets.sprites.push(c.sprite);
          }
        } else {
          c.anims.forEach( (anim) => {
            anim.frames.forEach( (frame) => {
              if (frame.atlas) {
                !self.assetAlreadyLoaded('sprite', frame.atlas) && assets.atlases.push(frame.atlas);
              } else {
                !self.assetAlreadyLoaded('sprite', frame.sprite) && assets.sprites.push(frame.sprite);
              }
            });
          });
        }
      }
    } else if (c.type === 'video') {
      //!self.assetAlreadyLoaded('video', c.video) && assets.videos.push(c.video);
      assets.videos.push(c.video);
    } else if (c.type === 'spineTransform') {
      if (!isObject(c.spine)) {
        !self.assetAlreadyLoaded('spineTransform', c.spine) && assets.spines.push(c.spine);
      }
    } else if (c.type === 'tiledSprite') {
      if (self.hasPacker) {
        return;
      }
      if (c.atlas) {
        !self.assetAlreadyLoaded('sprite', c.atlas) && assets.atlases.push(c.atlas);
      } else {
        !self.assetAlreadyLoaded('sprite') && assets.sprites.push(c.texture);
      }
    } else if (c.type === "playSound") {
      !self.assetAlreadyLoaded('sound') && assets.sounds.push(c.sound);
    } else if (c.type === 'tileMap') {
      c.tiled.tilesets.forEach( (tileset) => {
        !self.assetAlreadyLoaded('tilemap', tileset.name) && assets.atlases.push(tileset.name);
      });
    } else if (c.type === 'particleTransform') {
      !self.assetAlreadyLoaded('particles') && assets.sprites.push(c.sprite);
    }
  }
  this.allComponents.forEach(getAssetsFromComponent);
  /*
  ((this.tiledata.remix||{}).components||[]).forEach(getAssetsFromComponent);

  // remix themes
  toPairs((this.tiledata.remix||{}).themes || {}).forEach( ([key,remixed]) => {
  const index = findIndex(this.tiledata.themes, (x) => {
  return x.name === key;
  });
  this.tiledata.themes[index] = remixed;
  });
  */

  assets.sounds = uniq(assets.sounds);
  assets.sprites = uniq(assets.sprites);
  assets.videos = uniq(assets.videos);
  assets.tilesets = uniq(assets.tilesets);
  assets.atlases = uniq(assets.atlases);
  assets.spines = uniq(assets.spines);

  return assets;
}

Assets.prototype.loadAssets = function (assets) {

  this.spritesTotal = assets.sprites.length;
  this.mipmappedTotal = assets.sprites.length;
  this.soundsTotal = assets.sounds.length;

  this.spritesLoaded = 0;
  this.soundsLoaded = 0;


  assets.sprites.forEach( (asset) => {
    const img = asset;
    if (!img) {
      console.warn('have undefined as a sprite');
      return;
    }
    if (isString(img)) {
      let url;
      url = this.api.makeImageUrl(img);

      // WTF: this is because Pixi is retarded and this magic
      // needs to be set to load images with no extension
      // but not for the atlases, otherwise they break
      // lol.

      // load the texture wep need
      if (url.toLowerCase().indexOf('.jpg') || url.toLowerCase().indexOf('.jpeg') || url.toLowerCase().indexOf('png') || url.toLowerCase().indexOf('webp') || url.toLowerCase().indexOf('gif')) {
        this.loader.add(img, url);
      } else {
        this.loader.add(img, url, {crossOrigin:true,image:true,loadType:'image',xhrType:'blob',contentType:'image/jpeg'})
      }
    } else {
      this.loader.add(img.name, img.b64);
    }
  })

  const videoPromises = VIDEO_ASSETS.loadVideos(assets.videos, this.api);
  VIDEO_ASSETS.sweepVideoControllers(this.videoPromises||[]);
  this.videoPromises = videoPromises;

  assets.atlases.forEach( (atlas) => {
    const url = this.api.makeSpritesheetUrl(atlas);
    if (url) {
      this.loader.add(atlas, url, {crossOrigin:true})
    }
  });

  assets.spines.forEach( (spine) => {
    const url = this.api.makeSpineUrl(spine);
    if (url) {
      this.loader.add(spine, url, {crossOrigin:true})
    }
  });


  // stupid pixie loader doesn't do anything if there are no assets
  // so add a fake asset to make it load
  //if (!this.hasPacker && assets.sprites.length === 0) {
    //this.loader.add('placeholder', this.api.makeImageUrl('placeholder.png'), {crossOrigin:true})
  //}
  // stupid pixie loader doesn't do anything if there are no assets
  // so just return :-(
  if (!this.hasPacker && assets.sprites.length === 0 && assets.atlases.length === 0 && videoPromises.length === 0) {
    return new Promise( (resolve) => {
      const mipmappedTextures = {};
      const resources = {};
      resolve({
        mipmappedTextures,
        resources
      });
    });
  }
  if (this.sounds) {
    values(this.sounds).forEach( (sound) => {
      sound.unload();
    } );
    this.sounds = {};
  } else {
    this.sounds = {};
  }

  return new Promise( (resolve,reject) => {
    forEach(assets.sounds, (sound, callback) => {
      const name = sound;
      const volume = typeof(sound.volume) !== 'undefined' ? parseFloat(sound.volume) : 0.3;
      //const url = 'https://s3-eu-west-1.amazonaws.com/insights-web-assets/sounds/' + sound;
      const url = this.api.makeSoundUrl(sound);

      var howlerSound = new Howl({
        src: [url],
        preload:false,
        format:'mp3',
        volume: volume *0.6
      });

      howlerSound.once('load', this.onLoadSound.bind(this, name, howlerSound, callback));
      howlerSound.once('loaderror', this.onLoadSoundError.bind(this, name, callback))

      howlerSound.load();

    }, async (err) => {
      this.loader.onProgress.add((progress) => {
        this.spritesLoaded = progress.progress/100 * assets.sprites.length;
        this.vue.$emit('progress', {
          progress,
          total:assets.sprites.length
        });
      });
      //this.loader.on('error', () => {
      //});
      this.loader.load( async (loader, resources) => {
        if (this.destroyed) {
          return;
        }
        const errors = values(resources).filter( (r) => {
          return r.error;
        }).map( (r) => {
          return r;
        });
        if (errors.length > 0) {
          const messages = errors.map( ({url,error:{message}}) => {
            return `[${url.slice(-50)}] ${message}`
          }).join("\n");
          this.gameState = 'error';
          return this.vue.$emit('error', messages);
        }
        //this.resources = resources;
        //this.mipmappedTextures = {};
        const mipmappedTextures = {};

        
        if (this.hasPacker) {
          resources['game_EN_web'].children.forEach( (child) => {
            toPairs(child.textures).forEach( ([key,tex]) => {
              // TODO: lol
              mipmappedTextures[key] = tex;
              mipmappedTextures[key + '.png'] = tex;
              mipmappedTextures[key + '.PNG'] = tex;
              mipmappedTextures[key + '.Png'] = tex;
              mipmappedTextures[key + '.jpg'] = tex;
              mipmappedTextures[key + '.JPG'] = tex;
              mipmappedTextures[key + '.Jpg'] = tex;
              mipmappedTextures[key + '.webp'] = tex;
              mipmappedTextures[key + '.WEBP'] = tex;
              mipmappedTextures[key + '.Webp'] = tex;
              mipmappedTextures[key + '.jpeg'] = tex;
              mipmappedTextures[key + '.Jpeg'] = tex;
              mipmappedTextures[key + '.JPEG'] = tex;
            })
          })
        }
        forEach(assets.sprites, (sprite, callback) => {
          let name,img;
          if (!sprite) {
            console.warn('have undefined sprite');
            setTimeout(callback, 0);
            return;
          }
          if (isString(sprite)) {
            name = sprite;
            img = sprite;
          } else {
            name = sprite.name;
            img = sprite.b64;
          }

          mipmappedTextures[name] = resources[name].texture;
          setTimeout(callback, 0);

        }, async () => {

          await Promise.all(videoPromises);

          resolve({mipmappedTextures,resources});
        });
      });
    });

  });

};
Assets.prototype.assetAlreadyLoaded = function (type, key) {
  const k = [type, key].join('-');
  if (!this.assetsAlreadyLoaded[k]) {
    this.assetsAlreadyLoaded[k] = true;
    return false;
  }
  return true;
};

Assets.prototype.cleanup = function () {
  Object.keys(this.loader.resources).forEach( (key) => {
    const resource = this.loader.resources[key];

    if (resource.spritesheet) {
      resource.spritesheet.destroy(true);
    }
    if (resource.texture) {
      resource.texture.destroy(true);
    }
    Object.keys(resource.textures||{}).forEach( (tex) => {
      const texture = resource.textures[tex];
      texture.destroy(true);
      delete resource.textures[tex];
    });

    delete this.loader.resources[key];

  });

  VIDEO_ASSETS.sweepVideoControllers(this.videoPromises||[]);
}

Assets.prototype.makeVideoUrl = function (video) {
  return this.api.makeVideoUrl(video);
}

Assets.prototype.claimVideoController = function (video) {
  VIDEO_ASSETS.claimVideoController(video);
}
Assets.prototype.getVideoController = function (video) {
  return VIDEO_ASSETS.getVideoController(video);
}

export default Assets;
